<template>
  <div>
    <v-autocomplete
      hide-details
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="descripcion_convenio"
      item-value="id_convenio"
      label="Convenio"
      persistent-hint
      return-object
      @change="$emit('input', select.id_convenio)"
    ></v-autocomplete>
    <v-text-field
      hide-details
      outlined
      dense
      label="Convenio"
      v-if="readonly === true && !texto"
      readonly
      filled
      :value="select.descripcion_convenio"
    ></v-text-field>
    <h3 v-if="texto">Convenio: {{ select.descripcion_convenio }}</h3>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
     texto: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      select: {
        id_convenio: 0,
        descripcion_convenio: "",
      },
    };
  },
  computed: {
    ...mapState("conveniosprestacionales", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      // l.push({
      //   id_convenio: 0,
      //   descripcion_convenio: " --Seleccione-- ",
      // });
      return l;
    },
  },
  methods: {
    seleccionar(id) {
      let pr = this.lista.find((x) => x.id_convenio == id);
       this.select = pr;
      // if (pr) {
      //   this.select = pr;
      // } else {
      //   this.seleccionar("0");
      // }
    },
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    },
  },
};
</script>

<style></style>
